import React, { useState, useEffect } from "react";
import TabList from "./TabList";
import Grid from "@mui/material/Grid";
import { Button, Typography, Box, Container } from "@mui/material";
import { items } from "../helpers/constants";
import Slide from "./Banner/Slide";
import Carouselcomp from "./Carousel/Carouselcomp";
import { Features } from "./Features";
import { useLocation } from "react-router-dom";
// Toaster
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const react_app_base_url = process.env.REACT_APP_BASE_URL;
//Components

const Index = () => {
  const search = useLocation().search;
  const operation = new URLSearchParams(search).get("operation");
  const [currentslide, setCurrentslide] = useState(0);
  const slidesrow = items?.map((el, i) => {
    return <Slide key={i} slide={el} index={i} currentslide={currentslide} />;
  });

  useEffect(() => {
    setCurrentslide(0);
    if (operation === "logout") {
      showToaster("Logged out successfully!");
    }
    else if(operation === "delete_account") {
      showToaster("Account deleted successfully!");
    }
  }, []);

  const showToaster = (msg) => {
    toast(msg);
  };

  const showAlert = () => {
    alert('development in progress');
  }
  return (
    <>
      {/* <ToastContainer /> */}
      <div className="home">
        <Carouselcomp
          slides={slidesrow}
          setCurrentslide={setCurrentslide}
          currentslide={currentslide}
        />
      </div>
      <Grid container>
        <Features />
      </Grid>
      <Grid container className="bg-color dowloadPlanner" py={5}>
        <Container maxWidth="lg">
          <Grid item xs={12}>
            <h1 data-aos="zoom-in">Download MoneyTrek Mobile App</h1>
            {/* data-aos="fade-left" */}
            <Typography fontSize={22} textAlign="center" data-aos="zoom-in">
              {/* data-aos="fade-left" */}
              Manage your Budgets/expenses effortlessly.
            </Typography>

            <Box textAlign="center" data-aos="zoom-in">
              {/* data-aos="fade-right" */}
              <a href="https://play.google.com/store/apps/details?id=com.jsonworld.moneytrek">
                <img src={`${react_app_base_url}images/google_playstore.png`} alt="playstore icon"/>
              </a>
              
              <span  onClick={showAlert} style={{cursor:'pointer'}}>
              <img src={`${react_app_base_url}images/apple_appstore.png`} alt="appstore icon"/>
              </span>
            </Box>
          </Grid>
        </Container>
      </Grid>
    </>
  );
};

export default Index;
